<script lang="ts" setup>
import type { DriverMobileDevice } from "@/api/users/dto/driver.dto";
import { useDateTime } from "@/composables";

const { timeAgo } = useDateTime();

const props = defineProps<{
  devices: DriverMobileDevice[];
}>();
</script>

<template>
  <ul class="devices">
    <li v-for="(device, index) of props.devices" :key="`${device.model}-${index}`">
      {{ index + 1 }}. {{ device.os }}, {{ device.model }},
      {{ device.lastLoginTime ? timeAgo(device.lastLoginTime) : null }}
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.devices {
  list-style-type: none;
}
</style>
